import React, { useState } from 'react'
import Cookies from 'universal-cookie'

import Modal from '../modal'
import Input from '../input'
import Form from '../form'
import message from '../message'

const cookies = new Cookies()
// 默认
let accountInfoDefault = {
  account: undefined,
  password: undefined,
}

export default ({ visible, close, signIn }) => {
  const [confirmLoading, setConfirmLoading] = useState(false)

  // 如果storage中已存在，则取storage
  const storageAccountInfo = localStorage.getItem('accountInfo')
  if (storageAccountInfo) {
    try {
      accountInfoDefault = JSON.parse(storageAccountInfo)
    } catch (e) {}
  }

  const [accountInfo, setAccountInfo] = useState(accountInfoDefault)
  const { account, password } = accountInfo

  const onSubmit = () => {
    setConfirmLoading(true)
    const returnVal = signIn && signIn(accountInfo)

    if (returnVal && returnVal.then) {
      returnVal
        .then((res) => {
          message.success('模拟登陆成功')
          localStorage.setItem('accountInfo', JSON.stringify(accountInfo))
          setConfirmLoading(false)
          setTimeout(() => {
            const { tdToken: token, userId } = res || {}

            cookies.set('_td_token_', token, { path: '/' })
            cookies.set('_uid_', userId, { path: '/' })
            close()
          }, 500)
        })
        .catch((err) => {
          setConfirmLoading(false)
          throw err
        })
    }
  }
  const changeFieldValue = (key, evt) => {
    setAccountInfo({
      ...accountInfo,
      [key]: evt.target.value,
    })
  }

  return (
    <Modal
      title="开发者模拟登陆"
      visible={visible}
      maskClosable={false}
      onOk={onSubmit}
      onCancel={close}
      confirmLoading={confirmLoading}
    >
      <Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }}>
        <Form.Item label="用户名：">
          <Input
            type="text"
            placeholder="请输入用户名"
            value={account || undefined}
            onChange={(evt) => changeFieldValue('account', evt)}
          />
        </Form.Item>
        <Form.Item label="密码：">
          <Input
            type="text"
            placeholder="请输入用户名"
            value={password || undefined}
            onChange={(evt) => changeFieldValue('password', evt)}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
